import { render, staticRenderFns } from "./AddNewCurrencyForm.vue?vue&type=template&id=11d39551&"
import script from "./AddNewCurrencyForm.vue?vue&type=script&lang=js&"
export * from "./AddNewCurrencyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports